import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import AddIcon from "@mui/icons-material/Add";
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { uniquesDurationAtom } from '../recoil/Atom';
import { IUniquesDuration } from '../local-interfaces/local-interfaces';

const HandleAddLevel = () => {
  const [duration, setDuration] = useState(0)
  const [uniquesDuration, setUniqueDuration] = useRecoilState<IUniquesDuration>(uniquesDurationAtom)


  const handleDurationChange = (e: any) => {
    const input = e.target.value;
    // Replace non-numeric characters with an empty string
    const filteredInput = input.replace(/\D/g, '');
    setDuration(+filteredInput);
  };

  const handleConfirm = () => {
    if (uniquesDuration.durations.includes(duration)) { return }
    setUniqueDuration((current) => { return { ...current, durations: [...current.durations, +duration] } })
    setDuration(0)
  }


  return <>
    <Box className='center' height={'100px'} flexDirection={'column'} justifyContent={'space-around'} borderTop={'1px solid #444'}>
      <Grid flexDirection={'row'} container alignItems={'center'} justifyContent={'space-around'}>
        <Grid xs={6} item alignItems={'center'}>
          <TextField
            variant='standard'
            value={duration}
            onChange={(e) => handleDurationChange(e)}
            onKeyDown={(e) => {
              e.stopPropagation();
              if (e.key === "Enter") {
                handleConfirm();
              }
            }}
            sx={{
              fontSize: '10px',
              textAlign: 'center',
              '& input': {
                textAlign: 'center',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'white'
              }
            }}
          />
        </Grid>
        <Grid xs={3} item mr={1}>
          <Typography>sec</Typography>
        </Grid>
      </Grid>
      <Button
        variant='text'
        onClick={handleConfirm} disabled={!uniquesDuration || uniquesDuration.durations.includes(duration)}

        sx={{
          flexDirection: 'row',
          display: 'flex',
          justifyContent: 'center',
          color: '#fff',
          width: '90%',
          borderRadius: 0
        }}
      >
        <AddIcon fontSize='small' />
        <Typography fontSize={'13px'} letterSpacing={1}> AWAIT</Typography>
      </Button>
    </Box>
  </>
}
export default HandleAddLevel

